import { Transfer } from "./transfer";
import { Wrapper } from "../Styles";

const History = () => {
  return (
    <Wrapper>
      <div className="flex flex-col w-full space-y-8">
        <Transfer />
      </div>
    </Wrapper>
  );
};

export default History;
